import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export const MEETING_PREP_SETTINGS_QUERY_KEY = ['meetingPrep', 'preferences'];

/**
 * Fetches the calling user's Meeting Prep preferences (GET /MeetingPrep/preferences). When the user
 * has never customized their settings, the API returns a transient defaults record with `id: null`;
 * render the form against it normally — the next PUT creates the row.
 */
export const useMeetingPrepSettings = ({
	userSession,
	enabled = true,
	meta,
}: {
	userSession: Api.UserSessionContext;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) => {
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IMeetingPrepUserSettings>('MeetingPrep/preferences', 'GET');
		},
		queryKey: MEETING_PREP_SETTINGS_QUERY_KEY,
		meta,
	});
};

export const invalidateMeetingPrepSettings = () =>
	reactQueryClient.invalidateQueries({ queryKey: MEETING_PREP_SETTINGS_QUERY_KEY });
